import $ from "jquery";

const createContainer = () => {
  if (!$(".ginput_container_fileupload").length) return;
  let fileFieldContainer = document.createElement("div");
  fileFieldContainer.className = "file-field-container";

  let elTarget = document.querySelector(".ginput_container_fileupload");
  elTarget.prepend(fileFieldContainer);
};

const moveButton = () => {
  if (!$("#gform_browse_button_1_11").length) return;

  let btn = document.querySelector("#gform_browse_button_1_11");
  let container = document.querySelector(".file-field-container");
  let fileDesc = document.querySelector(".ginput_preview_list");

  container.prepend(btn);
  container.prepend(fileDesc);
};

const init = () => {
  createContainer();
  moveButton();
};

try {
  init();
} catch (error) {
  console.log(error);
}
